/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import NoneEmphasis from 'solis/react/board/emphasis/none';

import StyledZone from 'solis/react/board/data/styled.zone';


export default class extends Logic
{
  constructor ({ data, emphasis = new NoneEmphasis(), dimming = new NoneEmphasis() })
  {
    super(data);

    this.emphasis = emphasis;
    this.dimming = dimming;
  }


  getCenterDisplayHex ()
  {
    return this.object.getCenterDisplayHex();
  }


  getZone (displayHex)
  {
    const zone = this.object.getZone(displayHex);

    return zone !== null ? new StyledZone(zone, this) : null;
  }


  getZones ()
  {
    return this.object.getZones().map(zone => new StyledZone(zone, this));
  }


  getSelectableZone (displayHex)
  {
    const zone = this.object.getSelectableZone(displayHex);

    return zone !== null ? new StyledZone(zone, this) : null;
  }


  toEntityHex (displayHex)
  {
    return this.object.toEntityHex(displayHex);
  }


  toDisplayHex (entityHex)
  {
    return this.object.toDisplayHex(entityHex);
  }


  equals (other)
  {
    return super.equals(other) && this.emphasis.equals(other.emphasis) && this.dimming.equals(other.dimming);
  }

};
